import React from "react";
import { createRoot } from "react-dom/client";
import "leaflet/dist/leaflet.css";
import "./styles/ds-colors-and-type.css";
import "./styles/ds-components.css";
import "./styles/ds-styles.css";
import "./styles/app.css";
import "./styles/chaos.css";
import App from "./App.jsx";

createRoot(document.getElementById("root")).render(<App />);
